import PropTypes from 'prop-types';
import React from 'react';

class DelayDisplay extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    delayMS: PropTypes.number
  }

  static defaultProps = {
    placeholder: null,
    delayMS: 1000
  }

  state = {
    show: false
  }

  componentDidMount() {
    this.timeout = setTimeout(()=>{
      this.setState({
        show: true
      });
    }, this.props.delayMS);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const {
      show
    } = this.state;

    const {
      children,
      placeholder:Placeholder=null
    } = this.props;

    if (show) {
      return children;
    }

    if (typeof placeholder == 'object' || typeof placeholder === 'string') {
      return <Placeholder />;
    }

    return Placeholder;
  }
}

export default DelayDisplay;
